import { render } from "./calendarAppuntamenti.vue?vue&type=template&id=cea2360c&ts=true"
import script from "./calendarAppuntamenti.vue?vue&type=script&lang=ts"
export * from "./calendarAppuntamenti.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__